<template>
  <div class="admin-users-page">

    <!-- ================= HEADER ================= -->
    <div class="page-header">
      <div>
        <h1>Platform Users</h1>
        <p>Manage administrators, staff accounts, and platform access.</p>
      </div>

      <div class="header-actions">

        <div class="search-box">
          <span class="material-symbols-outlined">search</span>
          <input
            placeholder="Search users..."
            v-model="searchQuery"
          />
        </div>

        <button class="filter-btn">
          All Roles
          <span class="material-symbols-outlined">expand_more</span>
        </button>

        <button
          class="primary-btn"
          @click="showAddModal = true"
        >
          <span class="material-symbols-outlined">add</span>
          Add User
        </button>

      </div>
    </div>

    <!-- ================= TABLE ================= -->
    <div class="table-card">

      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Role</th>
            <th>Status</th>
            <th>Last Activity</th>
            <th>Date Created</th>
            <th class="right">Actions</th>
          </tr>
        </thead>

        <tbody>

          <!-- LOADING -->
          <tr v-if="loading">
            <td colspan="6" class="muted" style="text-align:center; padding:40px;">
              Loading users...
            </td>
          </tr>

          <!-- USERS -->
          <tr
            v-for="user in filteredUsers"
            :key="user.id"
            v-else
          >

            <!-- USER -->
            <td>
              <div class="user-cell">

                <div class="avatar">
                  {{ user.initials }}
                </div>

                <div>
                  <div class="name">
                    {{ user.name }}
                  </div>
                  <div class="meta">
                    {{ user.email }}
                  </div>
                </div>

              </div>
            </td>

            <!-- ROLE -->
            <td>
              <span
                :class="[
                  'role-badge',
                  user.role.toLowerCase().replace(' ', '-')
                ]"
              >
                {{ user.role }}
              </span>
            </td>

            <!-- STATUS -->
            <td>
              <span
                :class="[
                  'status-pill',
                  user.status.toLowerCase()
                ]"
              >
                {{ user.status }}
              </span>
            </td>

            <!-- ACTIVITY -->
            <td class="muted">
              {{ user.activity }}
            </td>

            <!-- CREATED -->
            <td class="muted">
              {{ user.created }}
            </td>

            <!-- ACTIONS -->
            <td class="right">

              <div class="actions-wrapper">

                <!-- <button
                  class="icon-btn"
                  @click="editUser(user)"
                >
                  <span class="material-symbols-outlined">
                    visibility
                  </span>
                </button> -->

                <button
                  v-if="user.id!=user_id"
                  class="mini-btn"
                  @click="toggleMenu(user.id)"
                >
                  <span class="material-symbols-outlined">
                    more_vert
                  </span>
                </button>

                <!-- ACTION MENU -->
                <div
                  v-if="activeMenu === user.id"
                  class="actions-menu"
                  style="text-align: left;"
                >

                  <div @click="editUser(user)">
                    Edit User
                  </div>

                  <div @click="resetPassword(user.id)">
                    Reset Password
                  </div>

                  <div
                    class="danger"
                    @click="toggleStatus(user)"
                  >
                    {{ user.status === 'active'
                        ? 'Suspend User'
                        : 'Activate User' }}
                  </div>

                </div>

              </div>

            </td>

          </tr>

          <!-- EMPTY STATE -->
          <tr v-if="!loading && users.length === 0">
            <td colspan="6" class="muted" style="text-align:center; padding:40px;">
              No users found.
            </td>
          </tr>

        </tbody>
      </table>

    </div>

    <!-- ================= ADD USER MODAL ================= -->
    <div v-if="showAddModal" class="modal-overlay">

      <div class="modal-card">

        <div class="modal-header">
          <h3>Add New User</h3>

          <button
            class="modal-close"
            @click="showAddModal = false"
          >
            <span class="material-symbols-outlined">
              close
            </span>
          </button>
        </div>

        <div class="modal-body">

          <div class="form-group">
            <label>Full Name</label>
            <input
              v-model="newUser.name"
              placeholder="Enter full name"
            />
          </div>

          <div class="form-group">
            <label>Email Address</label>
            <input
              v-model="newUser.email"
              placeholder="Enter email address"
            />
          </div>

          <div class="form-group">
            <label>User Role</label>
            <select v-model="newUser.role">
              <option>Super Admin</option>
              <option>Support</option>
              <option>Finance</option>
            </select>
          </div>

        </div>

        <div class="modal-footer">

          <button
            class="ghost-btn"
            @click="showAddModal = false"
          >
            Cancel
          </button>

          <button
            class="primary-btn"
            @click="addUser"
          >
            Create User
          </button>

        </div>

      </div>

    </div>
<!-- ================= EDIT USER MODAL ================= -->
<div v-if="showEditModal" class="modal-overlay">

  <div class="modal-card">

    <div class="modal-header">
      <h3>Edit User</h3>

      <button
        class="modal-close"
        @click="showEditModal = false"
      >
        <span class="material-symbols-outlined">
          close
        </span>
      </button>
    </div>

    <div class="modal-body">

      <div class="form-group">
        <label>Full Name</label>
        <input
          v-model="editForm.name"
          placeholder="Enter full name"
        />
      </div>

      <div class="form-group">
        <label>User Role</label>
        <select v-model="editForm.role">
          <option>Super Admin</option>
          <option>Support</option>
          <option>Finance</option>
        </select>
      </div>

    </div>

    <div class="modal-footer">

      <button
        class="ghost-btn"
        @click="showEditModal = false"
      >
        Cancel
      </button>

      <button
        class="primary-btn"
        @click="updateUser"
      >
        Update User
      </button>

    </div>

  </div>

</div>
  </div>
</template>
<script>
import {
  getAdminUsers,
  createAdminUser,
  changeAdminUserStatus,
  resetAdminUserPassword,
  updateAdminUser
} from "../apis/adminUsersApis";
import {useToast} from 'vue-toastification';

export default {
  name: "AdminUsers",

  data() {
    return {
      toast:null,
      showEditModal: false,
      editForm: {
        id: null,
        name: "",
        role: "Support"
      },
      showAddModal: false,

      newUser: {
        name: "",
        email: "",
        role: "Support"
      },

      searchQuery: "",
      activeMenu: null,
      users: [],
      loading: false,
      user_id:""

    };
  },

  mounted() {
    const tmp = sessionStorage.getItem("ldata")||"";
    if(tmp && tmp.length>0){
      this.user_id = JSON.parse(tmp).user_id;
    }
    this.toast = useToast();
    this.loadUsers();
  },

  watch: {
    searchQuery() {
      this.loadUsers();
    }
  },

  computed: {
    filteredUsers() {
      return this.users;
    }
  },

  methods: {

    /* ================= LOAD USERS ================= */
    async loadUsers() {

      this.loading = true;

      const res = await getAdminUsers(
        this.searchQuery,
        "All"
      );

      if (res.status) {

        this.users = res.data.map(u => ({

          id: u.user_id,
          name: u.user_name,
          email: u.user_email,

          initials: u.user_name
            ? u.user_name
                .split(" ")
                .map(n => n[0])
                .join("")
                .substring(0, 2)
                .toUpperCase()
            : "--",

          role: u.user_type || "Support",
          status: u.user_status || "Active",
          activity: u.user_last_login || "—",
          created: u.user_datetime || "—"

        }));
      }

      this.loading = false;
    },


    /* ================= TOGGLE MENU ================= */
    toggleMenu(id) {
      this.activeMenu = this.activeMenu === id ? null : id;
    },


    /* ================= CREATE USER ================= */
    async addUser() {

      if (!this.newUser.name || !this.newUser.email) return;

      const res = await createAdminUser(
        this.newUser.name,
        this.newUser.email,
        this.newUser.role
      );

      if (res.status) {

        this.newUser.name = "";
        this.newUser.email = "";
        this.newUser.role = "Support";

        this.showAddModal = false;

        this.loadUsers();
      }
    },


    /* ================= RESET PASSWORD ================= */
    async resetPassword(user_id) {

      const res = await resetAdminUserPassword(user_id);

      if (res.status) {
        this.toast.success("Password reset to: " + res.new_password);
      }

      this.activeMenu = null;
    },


    /* ================= SUSPEND / ACTIVATE ================= */
    async toggleStatus(user) {

      const newStatus =
        user.status === "active"
          ? "suspended"
          : "active";

      const res = await changeAdminUserStatus(
        user.id,
        newStatus
      );

      if (res.status) {
        this.loadUsers();
      }

      this.activeMenu = null;
    },

    async updateUser() {

      if (!this.editForm.name) return;

      const res = await updateAdminUser(
        this.editForm.id,
        this.editForm.name,
        this.editForm.role
      );

      if (res.status) {

        this.showEditModal = false;

        this.editForm = {
          id: null,
          name: "",
          role: "Support"
        };

        this.loadUsers();
      }
    },
    /* ================= EDIT (Placeholder) ================= */
    editUser(user) {

      this.editForm.id = user.id;
      this.editForm.name = user.name;
      this.editForm.role = user.role;

      this.showEditModal = true;
      this.activeMenu = null;
    },

  }
};
</script>

<style scoped>
/* ================= PAGE ================= */

.admin-users-page {
  padding: 28px;
  background: #f6f7f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0; /* ✅ Prevent flex overflow */
}

/* ================= HEADER ================= */

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
}

.page-header h1 {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
}

.page-header p {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

/* ================= HEADER ACTIONS ================= */

.header-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

/* ================= SEARCH ================= */

.search-box {
  height: 40px;
  background: white;
  border-radius: 12px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  min-width: 220px;
  transition: 0.15s;
}

.search-box:focus-within {
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.12);
}

.search-box span {
  font-size: 18px;
  color: #94a3b8;
}

.search-box input {
  border: none;
  outline: none;
  font-size: 13px;
  width: 100%;
  background: transparent;
}

/* ================= BUTTONS ================= */

.primary-btn {
  height: 40px;
  padding: 0 16px;
  background: #197fe6;
  border-radius: 12px;
  border: none;
  color: white;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: 0.15s;
  white-space: nowrap;
}

.primary-btn:hover {
  background: #166fd1;
}

.filter-btn {
  height: 40px;
  padding: 0 14px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: 0.15s;
}

.filter-btn:hover {
  background: #f8fafc;
}

/* ================= TABLE ================= */

.table-card {
  background: white;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
  box-shadow: 0 10px 30px rgba(0,0,0,0.04);
  min-width: 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
}

/* ================= TABLE HEADER ================= */

thead {
  background: #f8fafc;
}

th {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 700;
  color: #94a3b8;
  padding: 14px 18px;
  text-align: left;
}

/* ================= TABLE BODY ================= */

td {
  padding: 16px 18px;
  border-top: 1px solid #f1f5f9;
  font-size: 13px;
  color: #0f172a;
  vertical-align: middle;
}

tbody tr:hover {
  background: #f8fafc;
}

/* ================= USER CELL ================= */

.user-cell {
  display: flex;
  gap: 10px;
  align-items: center;
  min-width: 0;
}

.avatar {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #197fe6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.name {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
}

.meta {
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

/* ================= ROLE BADGES ================= */

.role-badge {
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

/* ✅ FIXED CLASS MATCHING */

.role-badge.super-admin {
  background: #eef2ff;
  color: #4f46e5;
}

.role-badge.support {
  background: #ecfdf5;
  color: #059669;
}

.role-badge.finance {
  background: #fff7ed;
  color: #ea580c;
}

/* ================= STATUS ================= */

.status-pill {
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.status-pill.active {
  background: #dcfce7;
  color: #166534;
}

.status-pill.suspended {
  background: #fee2e2;
  color: #991b1b;
}

/* ================= ACTIONS ================= */

.actions-wrapper {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
}

/* ================= ICON BUTTONS ================= */

.icon-btn,
.mini-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.15s;
  padding: 0;
}

.icon-btn span,
.mini-btn span {
  font-size: 18px;
  color: #64748b;
}

.icon-btn:hover,
.mini-btn:hover {
  background: #f1f5f9;
}

.icon-btn:hover span,
.mini-btn:hover span {
  color: #197fe6;
}

/* ================= ACTION MENU ================= */

.actions-menu {
  position: absolute;
  right: 0;
  top: 36px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 15px 40px rgba(0,0,0,0.08);
  width: 170px;
  z-index: 50;
  animation: menuEnter 0.12s ease;
}

.actions-menu div {
  padding: 10px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: 0.12s;
}

.actions-menu div:hover {
  background: #f1f5f9;
}

.actions-menu .danger {
  color: #ef4444;
}

/* ================= UTILS ================= */

.muted {
  color: #94a3b8;
  font-size: 12px;
}

.right {
  text-align: right;
}

/* ================= ANIMATION ================= */

@keyframes menuEnter {
  from {
    transform: translateY(4px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
}

/* ================= MOBILE ================= */

@media(max-width:768px) {

  .admin-users-page {
    padding: 16px;
  }

  .header-actions {
    width: 100%;
  }

  .search-box {
    width: 100%;
    min-width: unset;
  }

  .filter-btn,
  .primary-btn {
    flex: 1;
    justify-content: center;
  }

}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  animation: fadeIn 0.15s ease;
}
.modal-card {
  width: 100%;
  max-width: 520px;
  background: white;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 25px 70px rgba(0,0,0,0.18);

  display: flex;
  flex-direction: column;

  animation: modalEnter 0.18s ease;
}
.modal-header {
  padding: 18px 20px;
  border-bottom: 1px solid #f1f5f9;

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #f1f5f9;

  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}
.modal-body input,
.modal-body select {
  height: 42px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-size: 13px;
  outline: none;
  transition: 0.2s;
  background: white;
}

.modal-body input:focus,
.modal-body select:focus {
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.12);
}
.modal-close {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.15s;
}

.modal-close span {
  font-size: 18px;
  color: #64748b;
}

.modal-close:hover {
  background: #f1f5f9;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes modalEnter {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (max-width: 640px) {

  .modal-card {
    max-width: 95%;
  }

  .modal-footer {
    flex-direction: column;
  }

  .modal-footer button {
    width: 100%;
  }
}

</style>
